import React from "react"
import {NavigationList, NavigationListLink} from "~/components/"
const settingsIcon = require("~/icons/settings_16_white.svg")

const SuperAdminNavigationList = () => (
  <NavigationList>
    <NavigationListLink to="/tenants" icon={settingsIcon}>
      Tenants
    </NavigationListLink>
  </NavigationList>
)

export default SuperAdminNavigationList



// WEBPACK FOOTER //
// ./src/components/navigations/SuperAdminNavigationList.js